import React from "react";
import styled from "styled-components";
import RotaryLogo from "../images/rotaryLogo.jpg";
import RotaractLogo from "../images/rotaract.jpg";
import PrimariaLogo from "../images/primariaLogo.jpg";
import InteractLogo from "../images/interactLogo.jpg";

const Section = styled.section`
  background: #ffffff;
  padding: 4rem 1.5rem 5rem;
  border-top: 1px solid rgba(10, 42, 74, 0.06);
`;

const Wrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.85rem;
  color: #faa71e;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

const Heading = styled.h2`
  font-size: clamp(1.6rem, 3.5vw, 2.2rem);
  color: #0a2a4a;
  font-weight: 800;
  margin-bottom: 2.5rem;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  align-items: center;
  justify-items: center;

  @media screen and (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
`;

const Card = styled.div`
  background: #fffcf2;
  border-radius: 16px;
  padding: 1.5rem;
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 28px -16px rgba(10, 42, 74, 0.25);
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: saturate(1.05);
  }
`;

const partners = [
  { img: RotaryLogo, alt: "Rotary" },
  { img: RotaractLogo, alt: "Rotaract" },
  { img: InteractLogo, alt: "Interact" },
  { img: PrimariaLogo, alt: "Primăria Timișoara" },
];

const Partners = () => {
  return (
    <Section id="parteneri">
      <Wrap>
        <Eyebrow>Alături de noi</Eyebrow>
        <Heading>Mulțumim partenerilor noștri</Heading>
        <Row>
          {partners.map((p) => (
            <Card key={p.alt}>
              <img src={p.img} alt={p.alt} />
            </Card>
          ))}
        </Row>
      </Wrap>
    </Section>
  );
};

export default Partners;
